// extracted by mini-css-extract-plugin
module.exports = {"container":"prompt_container__13s_l","active":"prompt_active__2GL4A","prompt-body":"prompt_prompt-body__2chug","special-btns":"prompt_special-btns__1_gHX"};